import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {
  private getItem<T>(key: string, defaultValue: T): T {
    const item = localStorage.getItem(key);

    if (!item) {
      return defaultValue;
    }

    try {
      return JSON.parse(item) as T;
    } catch (error) {
      return defaultValue;
    }
  }

  private setItem(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  get educationalCenter(): any | null {
    return this.getItem<any>('educationalCenters', null);
  }

  get isInitialLevel(): boolean {
    return this.educationalCenter && this.educationalCenter.level!.id === 1;
  }

  get currentUser(): any {
    return this.getItem<any>('currentUser', null);
  }

  get systemOwner(): boolean {
    return this.currentUser && this.currentUser.authToken && this.currentUser.authToken.claims && this.currentUser.authToken.claims.scopes ? this.currentUser.authToken.claims.scopes.systemOwner : false;
  }

  get operatorId(): number {
    return this.currentUser && this.currentUser.person ? this.currentUser.person.operatorId : 0;
  }

  get operatorRoles(): any[] {
    return this.getItem<any[]>('operatorRoles', []);
  }

}


// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/services/local-storage.service.ts